/**
 * Product page in-page anchors — smooth scroll to reviews and bundle sections.
 */
(function () {
  var ANCHORS = {
    'customer-reviews': 'a.product-rating-badge[href="#customer-reviews"]',
    'product-bundles': 'a[href="#product-bundles"]',
  };

  function scrollToAnchor(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) {
      history.replaceState(null, '', '#' + id);
    } else {
      window.location.hash = id;
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href').slice(1);
    if (hash !== 'customer-reviews' && hash !== 'product-bundles') return;

    if (hash === 'customer-reviews' && !link.matches('a.product-rating-badge')) return;

    event.preventDefault();
    scrollToAnchor(hash);
  });

  Object.keys(ANCHORS).forEach(function (id) {
    if (window.location.hash === '#' + id) {
      window.requestAnimationFrame(function () {
        scrollToAnchor(id);
      });
    }
  });
})();
